var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{staticClass:"flex-column"},_vm._l((_vm.users),function(user){return _c('v-col',{key:user.hash},[_c('UsersItem',{attrs:{"user":user}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }